// The demo's one "today" for claim data (rcm-31 §3): the real date. Nothing in
// the claim history may be dated after it. (components/lists keeps its own
// MOCK_NOW for the calendar's Friday scene; claims data uses this.)

export const CLAIMS_TODAY_ISO = '2026-10-18';

/** Local midnight of today. */
export const CLAIMS_TODAY = new Date(2026, 9, 18);

/** Latest clock minute an event on "today" may carry (11:30 AM). */
export const CLAIMS_TODAY_MAX_MIN = 11 * 60 + 30;
